import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/client';
import { useAuth } from './AuthContext';

const ServiceContext = createContext();

// Service types are per-company (per org) and live on the server, scoped by the
// logged-in workspace. They are NEVER read from browser storage, so one company's
// services can never appear in another company's account.
export function ServiceProvider({ children }) {
  const { user, isAuthenticated } = useAuth();
  const [services, setServices] = useState([]);

  // One-time cleanup of the old browser-stored list that used to bleed across accounts.
  useEffect(() => {
    try {
      localStorage.removeItem('ryzenos_services');
      localStorage.removeItem('ryzenos_svc_reset');
    } catch {}
  }, []);

  // Load this org's services whenever the signed-in user changes (login / account switch).
  useEffect(() => {
    if (!api.getToken() || !isAuthenticated) { setServices([]); return; }
    api.settings.get()
      .then(d => setServices(Array.isArray(d.services) ? d.services : []))
      .catch(() => {});
  }, [user?.id, isAuthenticated]);

  const persist = (next) => {
    setServices(next);
    api.settings.save({ services: next }).catch(() => {});
  };
  const add    = (s) => { const t = s.trim(); if (t && !services.includes(t)) persist([...services, t]); };
  const remove = (s) => persist(services.filter(x => x !== s));
  const edit   = (old, nw) => { const t = nw.trim(); if (t) persist(services.map(x => x === old ? t : x)); };

  return <ServiceContext.Provider value={{ services, add, remove, edit }}>{children}</ServiceContext.Provider>;
}

export const useServices = () => useContext(ServiceContext);
